import { render, staticRenderFns } from "./MakeAppointment.vue?vue&type=template&id=81d6d79a&scoped=true&"
import script from "./MakeAppointment.vue?vue&type=script&lang=js&"
export * from "./MakeAppointment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d6d79a",
  null
  
)

export default component.exports